/* MCD UI-Baukasten JS (2026-07-13): geteilte Motion-Helfer fuer Story + PDP.
   Vor den Seiten-Skripten laden (defer haelt die Reihenfolge). */
window.MCD = window.MCD || {};

/* beat(p, n, hold): rastender Scroll-Fortschritt ("einrasten" statt roh scrubben,
   Jonas 13.07., Apple-Muster: stabile Beats + kurze geeaste Uebergaenge).
   Teilt p (0..1) in n Spannen; jede Raststufe haelt ~hold der Spanne,
   der Wechsel laeuft als smoothstep-Rampe. Rueckgabe wieder 0..1.
   Die nachgelagerte Lerp-Daempfung der Seiten macht daraus weiche Bewegung. */
window.MCD.beat = function (p, n, hold) {
  hold = hold === undefined ? 0.55 : hold;
  var u = Math.min(Math.max(p, 0), 1) * n;
  var i = Math.floor(u); if (i >= n) i = n - 1;
  var f = u - i, a = hold / 2, b = 1 - hold / 2;
  var t = f <= a ? 0 : f >= b ? 1 : (f - a) / (b - a);
  t = t * t * (3 - 2 * t);
  return (i + t) / n;
};

/* pager(track, {itemSel, onIndex}): mobiler Galerie-Pager (Jonas 13.07. abends).
   EIN Wisch = EIN Schritt, egal wie schnell/stark gewischt wird: horizontal
   1:1 draggen, beim Loslassen genau eine Karte vor/zurueck (Schwelle 34px),
   Gummiband an den Enden. Vertikal bleibt natives Scrollen (touch-action:pan-y).
   Nur dort initialisieren, wo gepagt werden soll (Bilder-Galerien, mobil). */
window.MCD.pager = function (track, opts) {
  opts = opts || {};
  var idx = 0, base = 0, dragX = 0, dragging = false, suppress = false;
  var startX = 0, startY = 0, horiz = null, steps = [];
  function items() {
    return opts.itemSel ? track.querySelectorAll(opts.itemSel) : track.children;
  }
  function measure() {
    steps = [];
    var kids = items();
    for (var i = 0; i < kids.length; i++) steps.push(kids[i].offsetLeft);
    var pad = steps.length ? steps[0] : 0;
    for (var j = 0; j < steps.length; j++) steps[j] -= pad;
    go(idx, true);
  }
  function maxIdx() { return Math.max(0, steps.length - 1); }
  function go(i, instant) {
    idx = Math.max(0, Math.min(maxIdx(), i));
    base = steps[idx] || 0;
    track.style.transition = instant ? "none" : "transform .45s cubic-bezier(.22,.9,.3,1)";
    track.style.transform = "translateX(" + (-base) + "px)";
    if (opts.onIndex) opts.onIndex(idx, steps.length);
  }
  track.style.touchAction = "pan-y";
  track.addEventListener("pointerdown", function (e) {
    dragging = true; horiz = null; startX = e.clientX; startY = e.clientY; dragX = 0;
  });
  track.addEventListener("pointermove", function (e) {
    if (!dragging) return;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (horiz === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) horiz = Math.abs(dx) > Math.abs(dy);
    if (!horiz) return;
    try { track.setPointerCapture(e.pointerId); } catch (_) { }
    dragX = ((idx === 0 && dx > 0) || (idx === maxIdx() && dx < 0)) ? dx * 0.35 : dx;
    track.style.transition = "none";
    track.style.transform = "translateX(" + (-(base - dragX)) + "px)";
  });
  function end() {
    if (!dragging) return;
    dragging = false;
    suppress = Math.abs(dragX) > 10;
    if (horiz) go(idx + (dragX < -34 ? 1 : dragX > 34 ? -1 : 0));
    horiz = null; dragX = 0;
  }
  track.addEventListener("pointerup", end);
  track.addEventListener("pointercancel", end);
  /* Drag darf die cardlink-Anker nicht ausloesen (Klick) und kein natives
     Link-/Bild-Draggen starten (das wuerde die Pointer-Events abbrechen) */
  track.addEventListener("click", function (e) {
    if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; }
  }, true);
  track.addEventListener("dragstart", function (e) { e.preventDefault(); });
  /* iOS: bei erkanntem Horizontal-Drag natives Scrollen aktiv unterbinden —
     touch-action:pan-y allein liess Safari die Geste teils abbrechen (Jonas 16.07.) */
  track.addEventListener("touchmove", function (e) {
    if (dragging && horiz) e.preventDefault();
  }, { passive: false });
  addEventListener("resize", measure);
  measure();
  return { go: go, measure: measure };
};

/* Mobil-Header-Drawer (snippets/mcd-mhead.liquid, Jonas 13.07.) */
(function () {
  function init() {
    var b = document.querySelector(".mcd-burger"), d = document.getElementById("mcdDrawer");
    if (!b || !d) return;
    function set(open) {
      if (open) { d.hidden = false; requestAnimationFrame(function () { d.classList.add("open"); }); }
      else { d.classList.remove("open"); setTimeout(function () { d.hidden = true; }, 300); }
      b.classList.toggle("open", open);
      b.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.classList.toggle("mcd-noscroll", open);
    }
    b.addEventListener("click", function () { set(d.hidden); });
    addEventListener("keydown", function (e) { if (e.key === "Escape" && !d.hidden) set(false); });
  }
  if (document.readyState === "loading") addEventListener("DOMContentLoaded", init); else init();
})();
